module.exports = __webpack_public_path__ + "img/amx-6.aa3510dc.jpg";